import React from "react";

const RemoveFavoriteIcon = ({ size = 14, fill = "var(--du-color-icon)", ...props }) => (
  <svg width={size} height={size} viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_9282_53)'>
      <path
        d='M34.915 11.6187L24.7136 10.1361L20.1534 0.890975C20.0288 0.63785 19.8239 0.432939 19.5708 0.308385C18.9359 -0.00500745 18.1645 0.256153 17.8471 0.890975L13.2868 10.1361L3.0855 11.6187C2.80425 11.6588 2.54711 11.7914 2.35023 11.9923C2.11222 12.2369 1.98107 12.5661 1.98559 12.9073C1.99011 13.2486 2.12993 13.5742 2.37434 13.8124L9.75514 21.0084L8.01139 31.1695C7.9705 31.4059 7.99666 31.649 8.0869 31.8713C8.17713 32.0935 8.32784 32.2861 8.52194 32.427C8.71603 32.568 8.94573 32.6518 9.18501 32.6688C9.42428 32.6859 9.66355 32.6356 9.87568 32.5236L19.0002 27.7262L28.1248 32.5236C28.3739 32.6562 28.6632 32.7003 28.9404 32.6521C29.6395 32.5316 30.1096 31.8687 29.9891 31.1695L28.2453 21.0084L35.6261 13.8124C35.827 13.6155 35.9596 13.3584 35.9998 13.0771C36.1083 12.374 35.6181 11.7231 34.915 11.6187ZM25.1395 19.9959L26.59 28.4454L19.0002 24.4597L11.4105 28.4495L12.8609 19.9999L6.72166 14.0133L15.2074 12.7798L19.0002 5.09365L22.7931 12.7798L31.2788 14.0133L25.1395 19.9959Z'
        fill={fill}
      />
    </g>
    <circle cx='28.2412' cy='21.5' r='5.5' fill='white' stroke={fill} strokeWidth='2' />
    <path d='M26.2852 22.56V20.864H30.3492V22.56H26.2852Z' fill={fill} />
    <defs>
      <clipPath id='clip0_9282_53'>
        <rect width='36' height='36' fill={fill} />
      </clipPath>
    </defs>
  </svg>
);

export default RemoveFavoriteIcon;
